import { render } from "./index.vue?vue&type=template&id=1cc5fe42"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1cc5fe42&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/bg-image/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cc5fe42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cc5fe42', __exports__)) {
    api.reload('1cc5fe42', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1cc5fe42", () => {
    api.rerender('1cc5fe42', render)
  })

}


export default __exports__